import { Watch, BaseTLTableComponent, AxiosResponse, Component, RoleService, RoleFilter, BaseTLTableBase } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class RoleListBase extends BaseTLTableComponent {

	protected selectedRoleId: number = 0;

	protected roleService: RoleService = new RoleService();

	protected callActionClick() {
		this.isBusy = true;
		this.roleService.delete(this.itemsSelected).then(() => this.fetchData()).catch(error => {
			var errorMessage = this.$t('userList.errorDelete').toString();
			super.showAlertModalWithErrorMessageList(errorMessage);
			this.isBusy = false;
		});
		this.itemsSelected = null;
		(this.$refs.rolesTable as BaseTLTableBase).clearSelected();
	}


	protected contentModal = this.$t('role.messageQuestionMain').toString();
	protected showAlertBeforeDeleteBase(itemsSelected: any) {
		
		var idRole = Number(itemsSelected);
		this.roleService.getById(idRole).then(res => {
			var content = this.$t('role.messageQuestionMain').toString();
			if (res.data.corUserRoleCount > 0) {
				this.isWarningBeforeDelete = true;
				content = this.$t('role.messageQuestionDelete1').toString() + res.data.corUserRoleCount +
					this.$t('role.messageQuestionDelete2').toString() + content;
			}
			this.contentModal = content;
			this.showAlertBeforeActionClickBase(itemsSelected, content);
		});		
	}


	protected setFields() {
		this.fields = [
			//{ key: 'identifier', label: this.$t('role.fieldIdentif'), trans: 'role.fieldIdentif', sortable: true, class: 'text-left' },
			{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', sortable: true, class: 'text-left', design: 'detail', thClass: 'firstColumnMichael' },
			{ key: 'description', label: this.$t('role.fieldDescription'), trans: 'role.fieldDescription', sortable: true, class: 'text-left' },
			{ key: 'actions', label: this.$t('role.fieldActions'), trans: 'role.fieldActions', class: 'text-right', thClass: 'lastColumnMichael' }
		]
	};

	protected setfilters(value: any) {
		if (value != null && value[0].lang == this.filters[0].lang) {
			this.filters = value;
		}
		else {
			this.filters = [
				//{ key: 'identifier', label: this.$t('role.filterIdentif'), trans: 'role.filterIdentif', selected: false, value: null, type: 'text' },
				{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
				{ key: 'description', label: this.$t('role.filterDescription'), trans: 'role.filterDescription', selected: false, value: null, type: 'text' }
			];
		}
	}

	protected created() {
		super.initializeRights('COR_Role_Create', 'COR_Role_Delete', 'COR_Role_Read', 'COR_Role_Update');
		super.created();
		super.setDetailName('RoleDetail');
	};

	protected fetchData() {
		super.fetchData();
	}


	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let roleFilter: RoleFilter = new RoleFilter(null, null, this.$store.state.idTenant);
		return this.roleService.getAllByFilter(roleFilter);
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}

	protected prepareItems(items: any[]) { }

	//@ts-ignore
	@Watch('$store.state.currentLanguage')
	changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
		this.setfilters(null);
	}
};